import { render, staticRenderFns } from "./apply_success.vue?vue&type=template&id=774cbf32&scoped=true&"
import script from "./apply_success.vue?vue&type=script&lang=js&"
export * from "./apply_success.vue?vue&type=script&lang=js&"
import style0 from "./apply_success.vue?vue&type=style&index=0&id=774cbf32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774cbf32",
  null
  
)

export default component.exports